<template>
    <div class="body">
        <div class="header">
            <img src="@/assets/622.jpg" alt=""/>
        </div>
         <mt-loadmore :bottom-method="getAgentPrechargeListHandler" :bottom-all-loaded="allLoaded"  :auto-fill="false" ref="loadmore">
            <van-row class="el-col-row">
                <van-col span="12" v-for="item in dataList" :key="item.id"  @click.native="linkOpen(item)">
                    <div class="item-data">
                        <img :src="item.img" alt=""/>
                        <div class="goodsTitle">{{item.name}}</div>
                    </div>
                </van-col>
            </van-row>
         </mt-loadmore>
        <div class="slecjg" @click="selectChange()">订单查询</div>
    </div>    
</template>
<script>
import {wxRequest} from '@/api/user.js' 
export default {
    data(){
        return {
            dataList:[],
            pageNo: 0,
            perPageNum: 10,
            allPage: 0,
            froms:'',
            allLoaded: false            
        }
    },
    created(){
         this.froms= this.$route.query.froms;
        this.getAgentPrechargeListHandler()
    },
    methods:{
        selectChange(){
            this.$router.push({name:'orderSearch'})
        },
        getAgentPrechargeListHandler(){
            this.pageNo += 1;
            var params = {
                pageNo: this.pageNo,
                perPageNum: this.perPageNum,
                froms:this.froms
            }
            wxRequest("applyChangeSim/all/shops", params, "post").then(res => {
                if(res.data.code == 200){
                   this.allPage = Math.ceil(res.data.data.totalNum / this.perPageNum)
                    if(this.pageNo == this.allPage){
                        this.allLoaded = true;
                    }
                    var data = res.data.data.resultList.map(item=>{
                        item.img = process.env.VUE_APP_IMG_URL + '/' + item.img
                        return item
                    })
                    this.dataList = this.dataList.concat(data)
                    this.$refs.loadmore.onBottomLoaded();    
                    this.$nextTick(function(){
                        window.scroll(0,0);
                    })                   
                }
            })
        },
        linkOpen(data){
            window.open(data.url)
        }
    }
}
</script>
<style lang="less" scoped>
    .body{
        height:100%;
        width: 100%;
        .header{
            padding-bottom:10px;
            img{
                width:100%;
            }
        }
        .item-data{
            padding:10px;
            img{
                width:100%;
            }
            .goodsTitle{
                font-size: 0.8rem;
                height: 2rem;
                line-height: 2rem;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
    .slecjg{
        width: 75px;
        height: 27px;
        background: rgba(0,0,0,.5);
        font-size: 12.5px;
        color: #fff;
        border-radius: 16px 0 0 16px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: fixed;
        top: 50px;
        right: 0;
    }
</style>